import React from 'react';
import TimeAgo from 'react-timeago';
import {ScheduleEditor} from '../utils/editSchedule';
import {apiVariables} from '../utils/variables';

/* eslint eqeqeq: "off" */
var dateFormat = require('dateformat');



export class Events extends React.Component{
    constructor(props){
        super(props);
        this.state = {events: null,
                        preFilterEvents: null}
        this.getEvents = this.getEvents.bind(this);
        this.filterMissed = this.filterMissed.bind(this);
        this.refresh = this.refresh.bind(this);
       
    }
    componentDidMount(){
        this.getEvents();
    }
    refresh(){
        this.getEvents();
    }
    getEvents(){
        fetch( apiVariables.apiLink + 'solutionmonitor/overview/eventOverview?organization=' + encodeURIComponent(this.props.CurrentOrganization), { 
        method: 'get', 
        credentials: apiVariables.credentials,
        headers: apiVariables.apiHeader
        })
        .then((response) => response.json())
        .then((responseJson) => {
            console.log( responseJson.document.Events)
            this.setState({events: responseJson.document.Events, preFilterEvents: responseJson.document.Events});

        });
    }
    filterMissed(e){
        if(e.target.checked){
            let filter = this.state.events;
            filter = filter.filter(function(item){
                return item.passedDeadline.search('TRUE') !== -1;
            });
            this.setState({events: filter});
        }
        else{
            this.setState({events: this.state.preFilterEvents});
        }
    }
    render(){
        if(this.state.events != null){
            return (
                <div>
                    <h1>Events Page</h1>

                    <div className="checkbox">
                        <label><input type="checkbox" onClick={this.filterMissed}/>Show only missed deadlines </label>
                    </div>

                    <div id="dashboard" className="row">
                            <div className="col-xl-12">
                            <div className="row">
                                <div className="col-xl-12">
                                <div id="piechartContainer" className="row">
                                    <div className="col-xl-12">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr >
                                            <th className="text-center">Solution</th>
                                            <th className="text-center">Event</th>
                                            <th className="text-center" colSpan = {5}>Schedule</th>   
                                            </tr>
                                        </thead>
                                        {this.state.events.map(((event, index) =>
                                            <EventTable refresh={this.refresh} event={event} key={index} CurrentOrganization={this.props.CurrentOrganization}/>
                                        ))}
                                        </table>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
            );
        }
        else{
            return <h1>Fetching Events</h1>
        }
    }
}

class EventTable extends React.Component{
    constructor(prop){
        super(prop);
        this.showHandler = this.showHandler.bind(this);
        this.state = {shown: false, editSchedule: false};
        this.reverseEvent = this.reverseEvent.bind(this);
        this.editSchedule = this.editSchedule.bind(this);
        this.eventOK = this.eventOK.bind(this);
    }

    eventOK(){
        let that = this;
        fetch( apiVariables.apiLink + 'solutionmonitor/event?organization=' + encodeURIComponent(this.props.CurrentOrganization) + '&solutionName=' + encodeURIComponent(this.props.event.solutionName)  + '&eventName=' + encodeURIComponent(this.props.event.eventName) +
        "&passedDeadline=" + encodeURIComponent("FALSE"), { 
        method: 'PUT',
        credentials: apiVariables.credentials,
        headers: apiVariables.apiHeader
        }).then(function(response){
            that.props.refresh();
        })
    }

    showHandler(e){
        this.setState({shown: !this.state.shown});
    }
    editSchedule(){
        this.setState({editSchedule: !this.state.editSchedule});
    }
    reverseEvent(e){
        let that = this;
        fetch(apiVariables.apiLink + 'solutionmonitor/status/reverseEvent?organization=' + encodeURIComponent(this.props.CurrentOrganization)   + '&solutionName=' + encodeURIComponent(this.props.event.solutionName) + '&eventName=' + encodeURIComponent(this.props.event.eventName), { 
        method: 'PUT',
        credentials: apiVariables.credentials,
        headers: apiVariables.apiHeader
        }).then(function(response){
            that.setState({shown: !that.state.shown});
            that.props.refresh();
        })
        
        
    }
    render(){
        return(
            <tbody>
                <tr className={ this.props.event.disabled == "TRUE" ? "hover disabled-TRUE" : " error-" +  this.props.event.passedDeadline} onClick={this.showHandler}>
                <td>{ this.props.event.solutionName }</td>
                <td>{ this.props.event.eventName }</td>
                    <td>
                        {this.props.event.months === null || this.props.event.months === "" ? <p className="noMargin inLine"> Months: All</p> : <p className="noMargin inLine">Months: { this.props.event.months }</p>}
                    </td>
                    <td>
                        {this.props.event.daysOfMonth === null || this.props.event.daysOfMonth === "" ? <p className="noMargin inLine"> Days: None</p> : <p className="noMargin inLine">Days: { this.props.event.daysOfMonth }</p>}
                    </td>
                    <td>
                        {this.props.event.daysOfWeek === null || this.props.event.daysOfWeek === "" ? <p className="noMargin inLine"> WeekDays: None</p> : <p className="noMargin inLine">WeekDays: { this.props.event.daysOfWeek }</p>}
                    </td>
                    <td>
                        {this.props.event.hours === null || this.props.event.hours === "" ? <p className="noMargin inLine"> Hours: All</p> : <p className="noMargin inLine">Hours: { this.props.event.hours }</p>}
                    </td>
                    <td>
                        {this.props.event.minutes === null || this.props.event.minutes === "" ? <p className="noMargin inLine"> Minutes: All</p> : <p className="noMargin inLine">Minutes: { this.props.event.minutes }</p>}
                    </td> 
                </tr>
                <tr>
                    <td className={this.state.shown ? "" : "hiddenRow hidden"} colSpan={7}>
                        <div className="col-md-12 accordion">
                            <div className="col-md-1" onClick={()=>this.reverseEvent()}>
                                {this.props.event.disabled == 'FALSE' ? 
                                    <div><span className="dropdown-glyph glyphicon glyphicon-pause"></span></div> :
                                    <div><span className="dropdown-glyph glyphicon glyphicon-play"></span></div>}
                                
                            </div> 
                                
                            <div className="col-md-10">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Next Deadline</th>
                                            <th>Has Run</th>
                                            <th>Deadline Missed</th>
                                            <th>Last Run</th>
                                            <th>Last Missed Deadline</th>
                                            <th>Total Runs</th>
                                            <th>Deadlines Missed</th>
                                            {this.props.event.passedDeadline == 'TRUE' && <th>Force OK</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{ dateFormat(new Date(parseInt(this.props.event.nextEventTimestamp, 10)), "dddd, dS mmmm, yyyy, h:MM:ss TT")}</td>
                                            {this.props.event.eventHappened === 'true' || this.props.event.eventHappened === "TRUE" ?
                                            <td><span className="glyphicon glyphicon-ok"></span></td> :
                                            <td><span className="glyphicon glyphicon-remove"></span></td>
                                            }
                                            {this.props.event.passedDeadline == 'TRUE'?
                                            <td><span className="glyphicon glyphicon-ok"></span></td> :
                                            <td><span className="glyphicon glyphicon-remove"></span></td>
                                            }
                                            <td>{ <TimeAgo date={this.props.event.lastHappening} /> }</td>
                                            {this.props.event.lastDeadlineMissed !== null || this.props.event.lastDeadlineMissed !== undefined ? 
                                            <td>{ dateFormat(this.props.event.lastDeadlineMissed, "dddd, dS mmmm, yyyy, h:MM:ss TT") }</td>:
                                            <td>Never</td>
                                            }
                                                               
                                            <td>{ this.props.event.totalHappenings }</td>                   
                                            <td>{ this.props.event.totalDeadlinesMissed }</td>
                                            {this.props.event.passedDeadline === 'TRUE' && 
                                            <td><span onClick={this.eventOK} className="glyphicon glyphicon-ok-sign clickable solution-glyph"></span></td>}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-md-1">
                                <div><span onClick={this.editSchedule} className="dropdown-glyph glyphicon glyphicon-check"></span></div>     
                            </div>
                            
                        </div>
                        {this.state.editSchedule &&
                            <div className="col-md-12">
                                <ScheduleEditor refresh={this.props.refresh} event={this.props.event} CurrentOrganization={this.props.CurrentOrganization}/>
                            </div>
                        }
                        
                    </td>
                </tr>
            </tbody>);
    }
}

export class EventViewer extends React.Component{
    constructor(props){
        super(props);
        this.state = {events: null}
        this.getEvents = this.getEvents.bind(this);
        this.refresh = this.refresh.bind(this);
    }
    componentDidMount(){
        this.getEvents();
    }
    refresh(){
        this.getEvents();
    }
    getEvents(){
        let that = this;
        fetch( apiVariables.apiLink + 'solutionmonitor/overview/eventOverview?organization=' + encodeURIComponent(this.props.CurrentOrganization), { 
        method: 'get',
        credentials: apiVariables.credentials,
        headers: apiVariables.apiHeader
        })
        .then((response) => response.json())
        .then((responseJson) => {
            let filter = responseJson.document.Events;
            if(filter != null){
                filter = filter.filter(function(item){
                    return item.solutionName.search(that.props.solutionName) !== -1;
                });
            }
            this.setState({events: filter});
        });
    }
    render(){
        if(this.state.events != null){
            
            return (
                
                <table className="table table-bordered table-hover">
                <thead>
                    <tr >
                    <th className="text-center">Solution</th>
                    <th className="text-center">Event</th>
                    <th className="text-center" colSpan = {5}>Schedule</th>   
                    </tr>
                </thead>
                {this.state.events.map(((event, index) =>
                    <EventTable refresh={this.refresh} event={event} key={index} CurrentOrganization={this.props.CurrentOrganization}/>
                ))}
                </table>
            );
        }
        else{
            return <h1>Fetching Events</h1>
        }
    }
}






// WEBPACK FOOTER //
// ./src/pages/events.js